module.exports = __webpack_public_path__ + "img/Na_h-Eileanan_Siar.b3e0ba2f.png";